import React from "react";
import "./menu-btn-card.css";
const MenuButton = (props) => {
  return (
    <div className=" menu-card__container">
      <div onClick={props.onClick} className="menu-card">
        <div className="menu-card__icon">
          <i className={props.icon}></i>
        </div>
        <div className="menu-card__info">
          <h4>{props.count}</h4>
          <span>{props.title}</span>
        </div>
      </div>
      <div className="menu-card__buttons-group">
        <div onClick={props.editOnclick} className="button menu-card__button">
          <i className="bx bx-edit"></i>
          Edit
        </div>
        <div onClick={props.viewOnclick}  className="button menu-card__button">
          <i className="bx bx-show-alt"></i>
          View
        </div>
      </div>
    </div>
  );
};

export default MenuButton;
